import { render, staticRenderFns } from "./SidebarLoginUserTab.vue?vue&type=template&id=8fcee524&scoped=true&"
import script from "./SidebarLoginUserTab.vue?vue&type=script&lang=js&"
export * from "./SidebarLoginUserTab.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLoginUserTab.vue?vue&type=style&index=0&id=8fcee524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcee524",
  null
  
)

export default component.exports